import { navigateTo } from '@v4/http/request';
import { parseUrl, stringifyUrl, trailingSlashIt } from '@v4/common/utils/url';

export default {
    methods: {
        navigateTo,
        onPagingClicked(page, pageUrl) {
            const { url, query } = parseUrl(pageUrl);

            this.navigateTo(stringifyUrl({ url: `${trailingSlashIt(url)}page/${page}`, query }));
        },
    },
};
